/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import ApiClient from '../../ApiClient'
import AutoActionApi from '../../api/AutoActionApi'
import ApiHandle from '../../util/ApiHandle'
import { appActions } from '../AppActions'
import history from '../../util/history'
import AppDispatcher from '../../core/AppDispatcher'

export const AutoMailContentActionTypes = {
  onEdit: 'auto_action/mail_content/edit-auto-action-mail-content',
  fetchOne: 'auto_action/mail_content/fetch-one',
  onCancel: 'auto_action/mail_content/on-cancel'
}

const autoActionApi = new AutoActionApi(ApiClient.instance)

const AutoMailContentActions = {
  getAutoActionMailContent: id => {
    const apiHandleOpts = {
      apiCall: () => autoActionApi.getAutoActionMailContent(id),
      onSucceded: response => {
        AppDispatcher.dispatchWithType(AutoMailContentActionTypes.fetchOne, response)
      },
      onErrored: error => {
        appActions.showError(error.response.body, '取得に失敗しました')
      }
    }
    ApiHandle(apiHandleOpts)
  },

  toEditView: id => {
    AppDispatcher.dispatchWithType(AutoMailContentActionTypes.fetchOne)
    history.push(`/auto_action/mail/${id}/content/edit`)
  },

  onEdit: event => {
    AppDispatcher.dispatchWithType(AutoMailContentActionTypes.onEdit, {
      name: event.target.name,
      value: event.target.value
    })
  },

  onCancel: () => {
    history.goBack()
  }
}

export default AutoMailContentActions
